import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/RegistrationOrganizer';

const RegistrationOrganizerReducer = handleActions({
    [Actions.callApiGetInformationXPAND]: (state) => ({
        ...state,
        isFetching: false,
    }),
    [Actions.callApiGetInformationXPANDReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        successInformation: true,
    }),
    [Actions.callApiGetInformationXPANDReceivedFailure]: (state, action) => ({
        ...state,
        errors: action.payload,
        isFetching: false,
        successInformation: false,
    }),
    [Actions.callApiCreateOrganizerReceived]: (state) => ({
        ...state,
        isFetching: false,
        successCreate: true,
    }),
    [Actions.callApiCreateOrganizerReceivedFailure]: (state, action) => ({
        ...state,
        errors: action.payload,
        successCreate: false,
    }),
    [Actions.clearGetInfomationData]: (state) => ({
        ...state,
        isFetching: false,
        data: {},
        errors: {},
        successInformation: false,
        successCreate: false,
    }),
    [Actions.callApiGetInformationRoom]: (state) => ({
        ...state,
        isFetching: false,
    }),
    [Actions.callApiGetInformationRoomReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        room: action.payload,
        successInformation: true,
    }),
    [Actions.callApiGetInformationRoom]: (state, action) => ({
        ...state,
        errors: action.payload,
        isFetching: false,
        successInformation: false,
    }),
    [Actions.clearCreateOrganizer]: (state) => ({
        ...state,
        room: [],
        isFetching: false,
        successCreate: false,
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    successInformation: false,
    successCreate: false,
    room: [],
});

export default combineReducers({
    registrationOrganizer: RegistrationOrganizerReducer,
});
